import { useSyncExternalStore } from 'react';

/**
 * O Pergaminho de Experiência do jogador (techspec-pergaminhos-loja §03): os segundos de combate que faltam, o % e se o
 * relógio está correndo (atacando mob fora da cidade e da vila de casas). Vem no quadro do próprio avatar.
 */
export interface PergaminhoXp {
  readonly segundos: number;
  readonly pct: number;
  readonly corre: boolean;
}

const SEM: PergaminhoXp = { segundos: 0, pct: 0, corre: false };
let atual: PergaminhoXp = SEM;
const ouvintes = new Set<() => void>();

/** Só avisa quando muda (o quadro chega 10 vezes por segundo). */
export function definirPergaminhoXp(segundos: number, pct: number, corre: boolean): void {
  const s = Math.max(0, Math.floor(segundos || 0));
  const p = Math.max(0, Math.floor(pct || 0));
  const c = s > 0 && !!corre;
  if (s === atual.segundos && p === atual.pct && c === atual.corre) return;
  atual = s > 0 ? { segundos: s, pct: p, corre: c } : SEM;
  for (const f of ouvintes) f();
}

export function pergaminhoXpAtual(): PergaminhoXp {
  return atual;
}

function assinar(f: () => void): () => void {
  ouvintes.add(f);
  return () => { ouvintes.delete(f); };
}

export function usePergaminhoXp(): PergaminhoXp {
  return useSyncExternalStore(assinar, pergaminhoXpAtual, pergaminhoXpAtual);
}

/** "1h05", "47:12": o tempo que falta, curto para caber embaixo do ícone. */
export function tempoDoPergaminho(segundos: number): string {
  const s = Math.max(0, Math.floor(segundos));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h > 0) return `${h}h${String(m).padStart(2, '0')}`;
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}

/** As artes de pergaminho do cliente da UO (frontend/public/sprites/itens/pergaminho). */
export const ARTES_PERGAMINHO = ['0x227a', '0x227b', '0x0e39', '0x0e35', '0x0e36', '0x0e3a', '0x2276', '0x0e34', '0x14f0'] as const;

export function arteDoPergaminho(arte: string | null | undefined): string {
  const id = (ARTES_PERGAMINHO as readonly string[]).includes(arte ?? '') ? arte : '0x0e34';
  return `/sprites/itens/pergaminho/${id}.png`;
}
